export function instrumentationQueueFactory() {
    return window.queuedEvents || [];
}
